import { render, staticRenderFns } from "./ItemListRigaMTM.vue?vue&type=template&id=aee00dca"
import script from "./ItemListRigaMTM.vue?vue&type=script&lang=ts"
export * from "./ItemListRigaMTM.vue?vue&type=script&lang=ts"
import style0 from "./ItemListRigaMTM.vue?vue&type=style&index=0&id=aee00dca&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aee00dca')) {
      api.createRecord('aee00dca', component.options)
    } else {
      api.reload('aee00dca', component.options)
    }
    module.hot.accept("./ItemListRigaMTM.vue?vue&type=template&id=aee00dca", function () {
      api.rerender('aee00dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListRigaMTM.vue"
export default component.exports